import {
  BusFill18Icon,
  CapacitySeatFill18Icon,
} from "@vygruppen/spor-icon-react";
import { Flex, Text } from "shared/components/Spor";
import { Nullish } from "shared/utils/objectUtils";

interface BussesPassengersCounterProps {
  vehicles: number;
  passengers: number;
  vehiclesFromMeasureCard: Nullish<number>;
}

export const BussesPassengersCounter = ({
  vehicles,
  passengers,
  vehiclesFromMeasureCard,
}: BussesPassengersCounterProps) => (
  <Flex color="semantics.colorTextSecondary" gap={1.5}>
    <Flex gap={1}>
      <Flex alignItems="center" gap={0.5}>
        <CapacitySeatFill18Icon />
        <Text variant="xs">{passengers}</Text>
      </Flex>

      <Text variant="xs">/</Text>

      <Flex alignItems="center" gap={0.5}>
        <BusFill18Icon />
        <Text variant="xs">{vehicles}</Text>
      </Flex>
    </Flex>

    {vehiclesFromMeasureCard && (
      <>
        <Text variant="xs">|</Text>
        <Flex gap={1}>
          <Text variant="xs">Tiltakskort:</Text>

          <Flex alignItems="center" gap={0.5}>
            <BusFill18Icon />
            <Text variant="xs">{vehiclesFromMeasureCard}</Text>
          </Flex>
        </Flex>
      </>
    )}
  </Flex>
);
